module.exports = __webpack_public_path__ + "static/media/LaffyFlow1.3e16bb82.png";